module.exports = __webpack_public_path__ + "static/river-6254367e00533746e0974ee13307f9a2.jpg";